import { getEnvVar } from '../utils/env';

export const redirectToLoginScreen = () => {
  window.location.href = `${getEnvVar('FE_AUTH_DOMAIN')}/login?sourceUrl=${getEnvVar('GALAXY_SOURCE_URL_REDIRECT_AFTER_SUCCESS_AUTH')}`;
};
